import React from 'react';
import i18n from 'i18next';
import { FiAlertCircle, FiAlertTriangle, FiInfo, FiRefreshCw } from 'react-icons/fi';
import './ErrorMessage.css';

/**
 * ErrorMessage - компонент отображения ошибок и предупреждений
 * @param {string} type - тип: 'error', 'warning', 'info', 'empty' (по умолчанию 'error')
 * @param {string} message - ключ перевода или текст сообщения
 * @param {string} details - дополнительные детали ошибки
 * @param {function} onRetry - функция повторной попытки (опционально)
 * @param {string} retryText - текст кнопки повтора (ключ перевода)
 */
const ErrorMessage = ({
    type = 'error',
    message,
    details,
    onRetry,
    retryText = 'retry'
}) => {
    const icons = {
        error: <FiAlertCircle className="error-icon" />,
        warning: <FiAlertTriangle className="error-icon" />,
        info: <FiInfo className="error-icon" />,
        empty: <FiInfo className="error-icon" />
    };

    // Try to translate, fall back to original if translation not found
    const tryTranslate = (key) => {
        if (!key) return key;
        const translated = i18n.t(key);
        // i18n.t returns the key if not found
        return translated;
    };

    const translatedMessage = tryTranslate(message);
    const translatedDetails = details ? tryTranslate(details) : null;
    const translatedRetry = tryTranslate(retryText);

    return (
        <div className={`error-container error-${type}`}>
            <div className="error-content">
                {icons[type]}
                <div className="error-text">
                    <p className="error-message">{translatedMessage}</p>
                    {translatedDetails && (
                        <p className="error-details">{translatedDetails}</p>
                    )}
                </div>
            </div>
            {onRetry && (
                <button className="error-retry-btn" onClick={onRetry}>
                    <FiRefreshCw className="retry-icon" />
                    {translatedRetry}
                </button>
            )}
        </div>
    );
};

export default ErrorMessage;
